/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type PreOpsQuestion,
    PreOpsQuestionFromJSON,
    PreOpsQuestionToJSON,
} from '../models/PreOpsQuestion';
import {
    type PreOpsQuestionCreate,
    PreOpsQuestionCreateFromJSON,
    PreOpsQuestionCreateToJSON,
} from '../models/PreOpsQuestionCreate';
import {
    type PreOpsQuestionSortKey,
    PreOpsQuestionSortKeyFromJSON,
    PreOpsQuestionSortKeyToJSON,
} from '../models/PreOpsQuestionSortKey';
import {
    type PreOpsQuestionUpdate,
    PreOpsQuestionUpdateFromJSON,
    PreOpsQuestionUpdateToJSON,
} from '../models/PreOpsQuestionUpdate';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface PreOpsQuestionsCreatePreOpsQuestionRequest {
    preOpsQuestionCreate: PreOpsQuestionCreate;
}

export interface PreOpsQuestionsDeletePreOpsQuestionRequest {
    questionId: string;
}

export interface PreOpsQuestionsListPreOpsQuestionsRequest {
    pageSize: number;
    search?: string | null;
    checklistId?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: PreOpsQuestionSortKey;
}

export interface PreOpsQuestionsListPreOpsQuestionsMetadataRequest {
    pageSize: number;
    search?: string | null;
    checklistId?: string | null;
}

export interface PreOpsQuestionsReadPreOpsQuestionRequest {
    questionId: string;
}

export interface PreOpsQuestionsUpdatePreOpsQuestionRequest {
    questionId: string;
    preOpsQuestionUpdate: PreOpsQuestionUpdate;
}

export interface PreOpsQuestionsValidateCreatePreOpsQuestionRequest {
    preOpsQuestionCreate: PreOpsQuestionCreate;
}

export interface PreOpsQuestionsValidateUpdatePreOpsQuestionRequest {
    questionId: string;
    preOpsQuestionUpdate: PreOpsQuestionUpdate;
}

/**
 * PreOpsQuestionsApi - interface
 * 
 * @export
 * @interface PreOpsQuestionsApiInterface
 */
export interface PreOpsQuestionsApiInterface {
    /**
     * Creates request options for preOpsQuestionsCreatePreOpsQuestion without sending the request
     * @param {PreOpsQuestionCreate} preOpsQuestionCreate 
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsCreatePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsCreatePreOpsQuestionRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new pre-ops checklist.
     * @summary Create a pre-ops checklist
     * @param {PreOpsQuestionCreate} preOpsQuestionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsCreatePreOpsQuestionRaw(requestParameters: PreOpsQuestionsCreatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreOpsQuestion>>;

    /**
     * Create a new pre-ops checklist.
     * Create a pre-ops checklist
     */
    preOpsQuestionsCreatePreOpsQuestion(requestParameters: PreOpsQuestionsCreatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreOpsQuestion>;

    /**
     * Creates request options for preOpsQuestionsDeletePreOpsQuestion without sending the request
     * @param {string} questionId 
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsDeletePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsDeletePreOpsQuestionRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the pre-ops checklists with the given ID.
     * @summary Delete a pre-ops checklists
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsDeletePreOpsQuestionRaw(requestParameters: PreOpsQuestionsDeletePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the pre-ops checklists with the given ID.
     * Delete a pre-ops checklists
     */
    preOpsQuestionsDeletePreOpsQuestion(requestParameters: PreOpsQuestionsDeletePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for preOpsQuestionsListPreOpsQuestions without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [checklistId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PreOpsQuestionSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsListPreOpsQuestionsRequestOpts(requestParameters: PreOpsQuestionsListPreOpsQuestionsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the checklists present.  If `search` is specified, return values similar to the `question` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.
     * @summary List pre-ops checklists
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [checklistId] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {PreOpsQuestionSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsListPreOpsQuestionsRaw(requestParameters: PreOpsQuestionsListPreOpsQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PreOpsQuestion>>>;

    /**
     * Lists all the checklists present.  If `search` is specified, return values similar to the `question` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.
     * List pre-ops checklists
     */
    preOpsQuestionsListPreOpsQuestions(requestParameters: PreOpsQuestionsListPreOpsQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PreOpsQuestion>>;

    /**
     * Creates request options for preOpsQuestionsListPreOpsQuestionsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [checklistId] 
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsListPreOpsQuestionsMetadataRequestOpts(requestParameters: PreOpsQuestionsListPreOpsQuestionsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Pre-ops checklist listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {string} [checklistId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsListPreOpsQuestionsMetadataRaw(requestParameters: PreOpsQuestionsListPreOpsQuestionsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Pre-ops checklist listing metadata
     */
    preOpsQuestionsListPreOpsQuestionsMetadata(requestParameters: PreOpsQuestionsListPreOpsQuestionsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for preOpsQuestionsReadPreOpsQuestion without sending the request
     * @param {string} questionId 
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsReadPreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsReadPreOpsQuestionRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the question specified by the given ID.
     * @summary Get a single question
     * @param {string} questionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsReadPreOpsQuestionRaw(requestParameters: PreOpsQuestionsReadPreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreOpsQuestion>>;

    /**
     * Returns the question specified by the given ID.
     * Get a single question
     */
    preOpsQuestionsReadPreOpsQuestion(requestParameters: PreOpsQuestionsReadPreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreOpsQuestion>;

    /**
     * Creates request options for preOpsQuestionsUpdatePreOpsQuestion without sending the request
     * @param {string} questionId 
     * @param {PreOpsQuestionUpdate} preOpsQuestionUpdate 
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsUpdatePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsUpdatePreOpsQuestionRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the checklist specified by the given ID.
     * @summary Update a pre-ops checklist
     * @param {string} questionId 
     * @param {PreOpsQuestionUpdate} preOpsQuestionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsUpdatePreOpsQuestionRaw(requestParameters: PreOpsQuestionsUpdatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreOpsQuestion>>;

    /**
     * Update the checklist specified by the given ID.
     * Update a pre-ops checklist
     */
    preOpsQuestionsUpdatePreOpsQuestion(requestParameters: PreOpsQuestionsUpdatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreOpsQuestion>;

    /**
     * Creates request options for preOpsQuestionsValidateCreatePreOpsQuestion without sending the request
     * @param {PreOpsQuestionCreate} preOpsQuestionCreate 
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsValidateCreatePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsValidateCreatePreOpsQuestionRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new checklist without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a checklist
     * @param {PreOpsQuestionCreate} preOpsQuestionCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsValidateCreatePreOpsQuestionRaw(requestParameters: PreOpsQuestionsValidateCreatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new checklist without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a checklist
     */
    preOpsQuestionsValidateCreatePreOpsQuestion(requestParameters: PreOpsQuestionsValidateCreatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for preOpsQuestionsValidateUpdatePreOpsQuestion without sending the request
     * @param {string} questionId 
     * @param {PreOpsQuestionUpdate} preOpsQuestionUpdate 
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsValidateUpdatePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsValidateUpdatePreOpsQuestionRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given checklist, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a pre-ops checklist update
     * @param {string} questionId 
     * @param {PreOpsQuestionUpdate} preOpsQuestionUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreOpsQuestionsApiInterface
     */
    preOpsQuestionsValidateUpdatePreOpsQuestionRaw(requestParameters: PreOpsQuestionsValidateUpdatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given checklist, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a pre-ops checklist update
     */
    preOpsQuestionsValidateUpdatePreOpsQuestion(requestParameters: PreOpsQuestionsValidateUpdatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class PreOpsQuestionsApi extends runtime.BaseAPI implements PreOpsQuestionsApiInterface {

    /**
     * Creates request options for preOpsQuestionsCreatePreOpsQuestion without sending the request
     */
    async preOpsQuestionsCreatePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsCreatePreOpsQuestionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['preOpsQuestionCreate'] == null) {
            throw new runtime.RequiredError(
                'preOpsQuestionCreate',
                'Required parameter "preOpsQuestionCreate" was null or undefined when calling preOpsQuestionsCreatePreOpsQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_questions/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreOpsQuestionCreateToJSON(requestParameters['preOpsQuestionCreate']),
        };
    }

    /**
     * Create a new pre-ops checklist.
     * Create a pre-ops checklist
     */
    async preOpsQuestionsCreatePreOpsQuestionRaw(requestParameters: PreOpsQuestionsCreatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreOpsQuestion>> {
        const requestOptions = await this.preOpsQuestionsCreatePreOpsQuestionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreOpsQuestionFromJSON(jsonValue));
    }

    /**
     * Create a new pre-ops checklist.
     * Create a pre-ops checklist
     */
    async preOpsQuestionsCreatePreOpsQuestion(requestParameters: PreOpsQuestionsCreatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreOpsQuestion> {
        const response = await this.preOpsQuestionsCreatePreOpsQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsQuestionsDeletePreOpsQuestion without sending the request
     */
    async preOpsQuestionsDeletePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsDeletePreOpsQuestionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling preOpsQuestionsDeletePreOpsQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_questions/{question_id}`;
        urlPath = urlPath.replace('{question_id}', encodeURIComponent(String(requestParameters['questionId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the pre-ops checklists with the given ID.
     * Delete a pre-ops checklists
     */
    async preOpsQuestionsDeletePreOpsQuestionRaw(requestParameters: PreOpsQuestionsDeletePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.preOpsQuestionsDeletePreOpsQuestionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the pre-ops checklists with the given ID.
     * Delete a pre-ops checklists
     */
    async preOpsQuestionsDeletePreOpsQuestion(requestParameters: PreOpsQuestionsDeletePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.preOpsQuestionsDeletePreOpsQuestionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for preOpsQuestionsListPreOpsQuestions without sending the request
     */
    async preOpsQuestionsListPreOpsQuestionsRequestOpts(requestParameters: PreOpsQuestionsListPreOpsQuestionsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling preOpsQuestionsListPreOpsQuestions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['checklistId'] != null) {
            queryParameters['checklist_id'] = requestParameters['checklistId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_questions/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the checklists present.  If `search` is specified, return values similar to the `question` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.
     * List pre-ops checklists
     */
    async preOpsQuestionsListPreOpsQuestionsRaw(requestParameters: PreOpsQuestionsListPreOpsQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PreOpsQuestion>>> {
        const requestOptions = await this.preOpsQuestionsListPreOpsQuestionsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PreOpsQuestionFromJSON));
    }

    /**
     * Lists all the checklists present.  If `search` is specified, return values similar to the `question` field. In that case, `sortKey` will not have any effect. I.e. results will be sorted by similarity to the search term instead.
     * List pre-ops checklists
     */
    async preOpsQuestionsListPreOpsQuestions(requestParameters: PreOpsQuestionsListPreOpsQuestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PreOpsQuestion>> {
        const response = await this.preOpsQuestionsListPreOpsQuestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsQuestionsListPreOpsQuestionsMetadata without sending the request
     */
    async preOpsQuestionsListPreOpsQuestionsMetadataRequestOpts(requestParameters: PreOpsQuestionsListPreOpsQuestionsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling preOpsQuestionsListPreOpsQuestionsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['checklistId'] != null) {
            queryParameters['checklist_id'] = requestParameters['checklistId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_questions/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Pre-ops checklist listing metadata
     */
    async preOpsQuestionsListPreOpsQuestionsMetadataRaw(requestParameters: PreOpsQuestionsListPreOpsQuestionsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.preOpsQuestionsListPreOpsQuestionsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Pre-ops checklist listing metadata
     */
    async preOpsQuestionsListPreOpsQuestionsMetadata(requestParameters: PreOpsQuestionsListPreOpsQuestionsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.preOpsQuestionsListPreOpsQuestionsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsQuestionsReadPreOpsQuestion without sending the request
     */
    async preOpsQuestionsReadPreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsReadPreOpsQuestionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling preOpsQuestionsReadPreOpsQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_questions/{question_id}`;
        urlPath = urlPath.replace('{question_id}', encodeURIComponent(String(requestParameters['questionId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the question specified by the given ID.
     * Get a single question
     */
    async preOpsQuestionsReadPreOpsQuestionRaw(requestParameters: PreOpsQuestionsReadPreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreOpsQuestion>> {
        const requestOptions = await this.preOpsQuestionsReadPreOpsQuestionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreOpsQuestionFromJSON(jsonValue));
    }

    /**
     * Returns the question specified by the given ID.
     * Get a single question
     */
    async preOpsQuestionsReadPreOpsQuestion(requestParameters: PreOpsQuestionsReadPreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreOpsQuestion> {
        const response = await this.preOpsQuestionsReadPreOpsQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsQuestionsUpdatePreOpsQuestion without sending the request
     */
    async preOpsQuestionsUpdatePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsUpdatePreOpsQuestionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling preOpsQuestionsUpdatePreOpsQuestion().'
            );
        }

        if (requestParameters['preOpsQuestionUpdate'] == null) {
            throw new runtime.RequiredError(
                'preOpsQuestionUpdate',
                'Required parameter "preOpsQuestionUpdate" was null or undefined when calling preOpsQuestionsUpdatePreOpsQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_questions/{question_id}`;
        urlPath = urlPath.replace('{question_id}', encodeURIComponent(String(requestParameters['questionId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PreOpsQuestionUpdateToJSON(requestParameters['preOpsQuestionUpdate']),
        };
    }

    /**
     * Update the checklist specified by the given ID.
     * Update a pre-ops checklist
     */
    async preOpsQuestionsUpdatePreOpsQuestionRaw(requestParameters: PreOpsQuestionsUpdatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PreOpsQuestion>> {
        const requestOptions = await this.preOpsQuestionsUpdatePreOpsQuestionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PreOpsQuestionFromJSON(jsonValue));
    }

    /**
     * Update the checklist specified by the given ID.
     * Update a pre-ops checklist
     */
    async preOpsQuestionsUpdatePreOpsQuestion(requestParameters: PreOpsQuestionsUpdatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PreOpsQuestion> {
        const response = await this.preOpsQuestionsUpdatePreOpsQuestionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for preOpsQuestionsValidateCreatePreOpsQuestion without sending the request
     */
    async preOpsQuestionsValidateCreatePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsValidateCreatePreOpsQuestionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['preOpsQuestionCreate'] == null) {
            throw new runtime.RequiredError(
                'preOpsQuestionCreate',
                'Required parameter "preOpsQuestionCreate" was null or undefined when calling preOpsQuestionsValidateCreatePreOpsQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_questions/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreOpsQuestionCreateToJSON(requestParameters['preOpsQuestionCreate']),
        };
    }

    /**
     * Validate data for a new checklist without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a checklist
     */
    async preOpsQuestionsValidateCreatePreOpsQuestionRaw(requestParameters: PreOpsQuestionsValidateCreatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.preOpsQuestionsValidateCreatePreOpsQuestionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new checklist without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a checklist
     */
    async preOpsQuestionsValidateCreatePreOpsQuestion(requestParameters: PreOpsQuestionsValidateCreatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.preOpsQuestionsValidateCreatePreOpsQuestionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for preOpsQuestionsValidateUpdatePreOpsQuestion without sending the request
     */
    async preOpsQuestionsValidateUpdatePreOpsQuestionRequestOpts(requestParameters: PreOpsQuestionsValidateUpdatePreOpsQuestionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['questionId'] == null) {
            throw new runtime.RequiredError(
                'questionId',
                'Required parameter "questionId" was null or undefined when calling preOpsQuestionsValidateUpdatePreOpsQuestion().'
            );
        }

        if (requestParameters['preOpsQuestionUpdate'] == null) {
            throw new runtime.RequiredError(
                'preOpsQuestionUpdate',
                'Required parameter "preOpsQuestionUpdate" was null or undefined when calling preOpsQuestionsValidateUpdatePreOpsQuestion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/pre_ops_questions/{question_id}/validate`;
        urlPath = urlPath.replace('{question_id}', encodeURIComponent(String(requestParameters['questionId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PreOpsQuestionUpdateToJSON(requestParameters['preOpsQuestionUpdate']),
        };
    }

    /**
     * Validate data for updating the given checklist, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a pre-ops checklist update
     */
    async preOpsQuestionsValidateUpdatePreOpsQuestionRaw(requestParameters: PreOpsQuestionsValidateUpdatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.preOpsQuestionsValidateUpdatePreOpsQuestionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given checklist, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a pre-ops checklist update
     */
    async preOpsQuestionsValidateUpdatePreOpsQuestion(requestParameters: PreOpsQuestionsValidateUpdatePreOpsQuestionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.preOpsQuestionsValidateUpdatePreOpsQuestionRaw(requestParameters, initOverrides);
    }

}
